module.exports = __webpack_public_path__ + "img/DESK.9cefdc40.svg";